export enum NotificationTypes {
    default = '#212121',
    success = '#4CAF50',
    warning = '#F9A825',
    error = '#F44336',
}
